// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bGTG","delete":"styles_delete__2dNKc","update":"styles_update__3lGmM","add":"styles_add__1tLvy"};